export const PET_SLICE_THICKNESS_MARKER = 'KAIROS_QOL2_PET_VIEWPORT_SLICE_THICKNESS';
export const PET_SLICE_THICKNESS_HELP_MARKER = 'KAIROS_QOL2_PET_AVG_SLAB_HELP_TOOLTIP';
export const PET_SLICE_THICKNESS_HELP_TEXT = 'PT AVG SLAB changes PET display thickness by averaging slices through the MIP path.';

export const PET_SLICE_THICKNESS_OPTIONS_MM = [1, 2, 5];

const withCacheEpoch = (url, cacheEpoch) => (
  cacheEpoch ? `${url}&ce=${encodeURIComponent(cacheEpoch)}` : url
);

export const standardViewportRenderUrl = (studyUID, seriesUID, slice, ww = 0, wc = 0, cacheEpoch = null) =>
  withCacheEpoch(`/render/study/${studyUID}/series/${seriesUID}?slice=${slice}&ww=${Math.round(ww)}&wc=${Math.round(wc)}`, cacheEpoch);

export const isPetSeries = (series) => {
  const modality = String(series?.modality || series?.Modality || '').trim().toUpperCase();
  return modality === 'PT' || modality === 'PET';
};

export const parsePositiveNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : null;
};

export const nativeSliceThicknessMm = (series) => (
  parsePositiveNumber(series?.sliceThickness)
  ?? parsePositiveNumber(series?.SliceThickness)
  ?? parsePositiveNumber(series?.slice_thickness)
  ?? parsePositiveNumber(series?.spacingBetweenSlices)
  ?? parsePositiveNumber(series?.spacing_between_slices)
  ?? null
);

export const slabSlicesForDisplayThickness = (thicknessMm, nativeMm = 1) => {
  const requested = parsePositiveNumber(thicknessMm) ?? 1;
  const native = parsePositiveNumber(nativeMm) ?? 1;
  return Math.max(1, Math.round(requested / native));
};

export const buildPetSliceThicknessRenderUrl = ({ studyUID, seriesUID, slice, ww = 0, wc = 0, series, thicknessMm = 1, cacheEpoch = null }) => {
  const nativeUrl = standardViewportRenderUrl(studyUID, seriesUID, slice, ww, wc, cacheEpoch);
  if (!isPetSeries(series)) return nativeUrl;
  const nativeMm = nativeSliceThicknessMm(series);
  if (!nativeMm) return nativeUrl;
  const slabSlices = slabSlicesForDisplayThickness(thicknessMm, nativeMm);
  if (slabSlices <= 1) return nativeUrl;
  return withCacheEpoch(`/render/study/${studyUID}/series/${seriesUID}/mip?plane=axial&slice=${slice}&slab=${slabSlices}&projection=average&ww=${Math.round(ww)}&wc=${Math.round(wc)}`, cacheEpoch);
};
